import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import FeteList from "./FeteList";
import { useState } from "react";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";

// Icons
import calenderIcon from "../../assets/images/callender-icon.svg";
import filterIcon from "../../assets/images/filter-icons.svg";
import CustomDropdown from "components/common/dropdown/Dropdown";
import { FETE_FILTERS } from "utils/constant";
import { optionProp } from "types";
import useAppState from "context/useAppState";
import { getUpcomingDate } from "utils/fete";
import { UPcomingFetesLoader } from "components/loaders";

const CurrentAndUpcomingFetes = ({ currentAndUpcomingEvents }: any) => {

	const { t } = useTranslation();
	const [dateRange, setDateRange] = useState<any>([null, null]);
	const [selectedValue, setSelectedValue] = useState<optionProp | null>(null);
	const [startDate, endDate]: any = dateRange;

	const [toggle, setToggle] = useState(0);

	const {
		setState,
		currentFetesLoading,
		currentAndUpcomingFetesFilter
	} = useAppState("eventList");

	const handleSelect = (selectedData: optionProp) => {
		setSelectedValue(selectedData);
		setState({
			is_past_events: false,
			currentAndUpcomingFetesFilter: {
				'format': selectedData.value
			},
			upcomingPage: 1
		})
	}

	const CustomPlaceholder = () => (
		<div className="flex items-center justify-between gap-x-2">
			<img src={filterIcon} alt="" />
			<span className="text-[#344054] font-interSemiBold" >Filters</span>
		</div>
	);

	const {
		control
	} = useForm({
		mode: 'onChange',
		defaultValues: {
			teamEmail: { value: "", label: "" },
			assignTask: { value: "", label: "" }
		}
	});

	const setUpcomingDate = (amount: number, unit: string) => {
		setState({
			is_past_events: false,
			upcomingDateFilter: {
				startDate: new Date(), endDate: getUpcomingDate(amount, unit)
			},
			upcomingPage: 1
		})
		setDateRange([]);
	}

	const setAllUpcomingDate = () => {
		setState({
			is_past_events: false,
			upcomingDateFilter: {
				startDate: new Date(), endDate: null
			},
			upcomingPage: 1
		})
		setDateRange([]);
	}

	const onDateRangeChanges = (dateRange: any) => {
		if (dateRange && dateRange[0] && dateRange[1]) {
			setState({
				is_past_events: false,
				upcomingDateFilter: {
					startDate: dateRange[0], endDate: dateRange[1]
				},
				currentAndUpcomingFetesFilter: currentAndUpcomingFetesFilter,
				upcomingPage: 1
			})
			setToggle(5)
		} else {
			setToggle(0)
			setUpcomingDate(12, 'months');
		}
		setDateRange(dateRange);
	}

	return (
		<div className="bg-[#fff] pb-6 px-10">
			<div className="pt-6 flex justify-between">
				<ul className="flex items-center">
					<li onClick={(e) => {
						setToggle(4)
						setAllUpcomingDate();
					}} className={`font-interSemiBold text-base py-2.5 px-4 border border-[#D0D5DD] rounded-tl-lg rounded-bl-lg flex items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb] ${toggle === 4 ? "bg-[#F9FAFB] pointer-none text-[#1e0af5]" : "bg-[#fff] text-[#344054]"}`}>
						<span className="text-sm font-interSemiBold">All</span>
					</li>

					<li onClick={(e) => {
						setToggle(0)
						setUpcomingDate(12, 'months');
					}} className={`font-interSemiBold text-base py-2.5 px-4 border border-[#D0D5DD] flex items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb] ${toggle === 0 ? "bg-[#F9FAFB] pointer-none text-[#1e0af5]" : "bg-[#fff] text-[#344054]"}`}>
						<span className="text-sm font-interSemiBold">12 Month</span>
					</li>

					<li onClick={(e) => {
						setToggle(1)
						setUpcomingDate(30, 'days')
					}} className={`font-interSemiBold text-base py-2.5 px-4 border border-[#D0D5DD] flex items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb] ${toggle === 1 ? "bg-[#F9FAFB] pointer-none text-[#1e0af5]" : "bg-[#fff] text-[#344054]"}`}>
						<span className="text-sm font-interSemiBold">30 Days</span>
					</li>

					<li onClick={(e) => {
						setToggle(2)
						setUpcomingDate(7, 'days')
					}} className={`font-interSemiBold text-base py-2.5 px-4 border border-[#D0D5DD] flex items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb] ${toggle === 2 ? "bg-[#F9FAFB] pointer-none text-[#1e0af5]" : "bg-[#fff] text-[#344054]"}`}>
						<span className="text-sm font-interSemiBold">7 Days</span>
					</li>
					<li onClick={(e) => {
						setToggle(3)
						setUpcomingDate(24, 'hours')
					}} className={`font-interSemiBold text-base py-2.5 px-4 border border-[#D0D5DD] flex rounded-tr-lg rounded-br-lg items-center gap-x-2 cursor-pointer hover:bg-[#f9fafb] ${toggle === 3 ? "bg-[#F9FAFB] pointer-none text-[#1e0af5]" : "bg-[#fff] text-[#344054]"}`}>
						<span className="text-sm font-interSemiBold">24 Hours</span>
					</li>
				</ul>

				<div className="flex gap-x-2">
					<div className="relative">
						<div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 bg-white hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
							<img
								className="w-[22px] h-[22px] flex-shrink-0 "
								src={calenderIcon}
								alt="star icon"
							/>
							<div className="custom-datepicker w-full datepicker-width-adjust adjust-z-layer">
								<DatePicker
									selectsRange={true}
									startDate={startDate}
									endDate={endDate}
									onChange={(dates: any) => onDateRangeChanges(dates)}
									minDate={new Date()}
									isClearable={true}
									placeholderText="Select dates"
									className="custom-datepicker-input placeholder:text-[#667085] placeholder:text-sm placeholder:font-interMedium text-sm text-[#667085] font-interMedium w-full"
								/>
							</div>
						</div>
					</div>
					<div>
						<div>
							<button className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] hover:border-[#1e0af5] rounded-lg tracking-wide !text-base flex items-center bg-white home-dropdown disable-hover-on-focus">
								<CustomDropdown
									name="upcomingEvent"
									control={control}
									placeholder={<CustomPlaceholder />}
									selectedValue={selectedValue}
									onChange={handleSelect}
									options={FETE_FILTERS}
								/>
							</button>
						</div>
					</div>

				</div>
			</div>
			<h3 className='text-[#101828] text-2xl font-interSemiBold pb-6 pt-6'>{t("dashboard.currentAndUpcomingEventsTitle")}</h3>
			<UPcomingFetesLoader count={currentFetesLoading ? 2 : 0} />
			{!currentFetesLoading && <FeteList events={currentAndUpcomingEvents?.data} total={currentAndUpcomingEvents?.total} type='upcoming' />}
		</div>
	)
}

export default CurrentAndUpcomingFetes;